module.exports = "https://cdn.realtymogul.com/static/media/icon_linkedin.d173410d.svg";